import { clearUser } from "@store/auth/userSlice.js";
import { store } from "@store/store.js";
import axios from "axios";

let navigateRef = null;

export const setAxiosNavigate = (navigate) => {
	navigateRef = navigate;
};

const axiosInstance = axios.create({
	baseURL: import.meta.env.VITE_API_BACKEND,
	headers: { "Content-Type": "application/json" },
});

axiosInstance.interceptors.request.use(
	(config) => {
		const state = store.getState();
		const token = state.auth.user.token;

		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}

		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response && error.response.status === 401) {
			store.dispatch(clearUser());

			if (navigateRef) {
				navigateRef("/login");
			} else {
				window.location.href = "/login";
			}
		}

		return Promise.reject(error);
	},
);

export default axiosInstance;
